




























































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import {
  Button,
  Form,
  FormItem,
  Input,
  Option,
  Radio,
  Select
} from 'element-ui';
import ModalCard from '@/components/layout/ModalCard.vue';
import { bankAccountService } from '@/services/BankAccountService';
import { bankAccountTypeOptions } from '@/constants/bankAccountTypeOptions';
import rules from '@/rules/rules';
import {
  BankAccountFields,
  BankAccountInput,
  BankAccountTypeEnum
} from '@/types/graphql/schemaTypes';

// mixins
import scrollError from '@/mixins/scrollError';

@Component({
  components: {
    ModalCard,
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-radio': Radio,
    'el-select': Select
  }
})
export default class BankAccountUpsert extends Mixins(scrollError) {
  @Prop({ default: null, type: Object }) bankAccount!: BankAccountFields | null;
  @Prop({ default: false, type: Boolean }) open!: boolean;

  private bankAccountInput: BankAccountInput | null = null;
  private loading = false;
  private readonly bankAccountTypeOptions = bankAccountTypeOptions();
  private readonly rules = rules;

  $refs!: {
    bankAccountForm: HTMLFormElement;
  };

  private close() {
    // resert
    this.defaultValue();
    this.$emit('close');
  }

  private submit(): void {
    this.$refs.bankAccountForm.validate(async(valid: boolean) => {
      if (!valid || !this.bankAccountInput) {
        this.scrollError(this.$refs.bankAccountForm);
        return;
      }

      this.loading = true;
      try {
        const bankAccountId = this.bankAccount ? this.bankAccount.id : undefined;
        const response = await bankAccountService.upsertBankAccount(
          this.bankAccountInput,
          bankAccountId
        );

        if (response.data) {
          this.$emit('close');
          this.$emit('refresh');
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
          this.defaultValue();
        }
      } catch (e) {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.loading = false;
      }
    });
  }

  private defaultValue() {
    this.bankAccountInput = {
      accountName: '',
      accountNumber: '',
      accountType: BankAccountTypeEnum.savings_account,
      bankAddress: '',
      bankCode: null,
      bankName: '',
      branchCode: null,
      branchName: null,
      customerOrganizationId: this.$route.params.id,
      realTime: false,
      swiftCode: null
    };
  }

  get realTimeRules() {
    if (this.bankAccountInput && this.bankAccountInput.realTime) {
      return this.rules.required;
    }
    return null;
  }

  @Watch('bankAccount', { immediate: true })
  private setData(bankAccount: BankAccountFields) {
    if (!bankAccount) {
      this.defaultValue();
    } else {
      this.bankAccountInput = {
        customerOrganizationId: bankAccount.customerOrganizationId,
        accountName: bankAccount.accountName || '',
        accountNumber: bankAccount.accountNumber || '',
        accountType: bankAccount.accountType || BankAccountTypeEnum.savings_account,
        bankAddress: bankAccount.bankAddress || '',
        bankCode: bankAccount.bankCode || null,
        bankName: bankAccount.bankName || '',
        branchCode: bankAccount.branchCode || null,
        branchName: bankAccount.branchName || null,
        realTime: bankAccount.realTime || false,
        swiftCode: bankAccount.swiftCode || null
      };
    }
  }
}
